<template>
  <div
    class="artist-info"
    v-if="artist"
  >
    <div class="artist-info__table">
        <div class="artist-info__btns">
            <button 
                :class="viewIndex === 1 && 'active'" 
                @click="changeIndex(1)"
            >O ARTYŚCIE</button>
            <button 
                :class="viewIndex === 2 && 'active'" 
                @click="changeIndex(2)"
            >UTWORY</button>
        </div>
      <div class="artist-info__left-column" v-if="viewIndex === 1">
        <div class="artist-info__top">
          <div class="artist-info__photo-container">
            <div
              class="artist-info__photo"
              v-bind:style="{ backgroundImage: 'url(' + artist.photo + ')' }"
              :class="{photoContentWithoutPhoto: !artist.photo}"
            >
            </div>
          </div>
          <div class="artist-info__artist-name">
            {{artist.name}}
          </div>
        </div>
        <div
          class="artist-info__content"
        >
          <div
            class="artist-info__photo-description"
            v-if="artist.description"
          >
            {{artist.description}}
          </div>
          <!-- <button v-if="artist.description.length > 600" class="artist-info__photo-description__btn-more">Wiecej</button> -->
        </div>
      </div>
      <div class="artist-info__right-column" v-if="viewIndex === 2">
        <div class="artist-info__song-list">
          <div
            class="artist-info__song"
            v-for="(song, index) in songs"
            :key="index"
            @click="()=>{goToSong(song.id)}"
          >
            <div class="artist-info__song-dot">
            </div>
            <p>{{song.name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin';

export default {
mixins: [mixin],
data() {
    return{
        viewIndex: 1
    }
},
methods: {
    changeIndex(index){
        this.viewIndex = index
    }
}
}
</script>

<style lang="scss" scoped>
  .artist-info {
    width: 100%;
    display: flex;
    justify-content: center;
    border-radius: 5px;
    margin-top: 2rem;
    
    &__content{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__table{
      display: flex;
      flex-direction: column;
      width: 93%;
      border-radius: 2px;
      background-color: #fefefe;
      box-shadow: 0 3px 6px rgba(0,0,0,0.1);
    }

    &__btns{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        margin-top: 2rem;
        width: 70%;
        button{
            width: 48%;
            background: #ebe6e6;
            color: #83818a;
            font-size: 1.2rem;
            border: none;
            border-radius: 4px;
            padding: 6px;
            font-weight: 600;
            outline: none;

            &.active{
                background: #dd2d62;
                color: #fefefe;
            }
        }
    }
    &__left-column {
      width: 100%;
      padding: 3rem 1rem 3rem 1rem;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      box-sizing: border-box;
    }
    &__top {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    &__artist-name {
      font-family: 'Poppins', sans-serif;
      color: #0f1626;
      font-size: 2rem;
      font-weight: 700;
      padding-bottom: 0.5rem;
      margin-top: 2rem;
      border-bottom: 1px solid rgba(169,169,169,0.6);
    }
    &__photo {
      width: 22rem;
      height: 12rem;
      border: 1px solid #e13368;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    &__photo-description {
      font-size: 1.2rem;
      font-family: 'Poppins', sans-serif;
      padding-top: 1rem;
      line-height: 1.7;
      text-align: center;
      &__btn-more{
          background: #dd2d62;
          border: none;
          border-radius: 3px;
          padding: 8px 20px;
          color: #fefefe;
          text-transform: uppercase;
          font-weight: 700;
          margin: 2rem auto;
          outline: none;
      }
    }
    &__right-column {
      width: 100%;
      padding: 3rem 1rem 1rem 1rem;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      box-sizing: border-box;
    }
    &__music-title {
      color: #d0d0e0;
      text-transform: uppercase;
      font-size: 1.2rem;
      font-family: 'Poppins', sans-serif;
      font-weight: 700;
      padding-bottom: 0.5rem;
    }
    &__song {
      cursor: pointer;
      color: #0f1626;
      font-size: 1.4rem;
      font-family: 'Poppins', sans-serif;
      padding-bottom: 1.4rem;
      display: flex;
      align-items: center;
      font-weight: 500;
    }
    &__song-dot {
      width: 0.4rem;
      height: 0.4rem;
      background-color: black;
      border-radius: 100%;
      margin-right: 1rem;
    }
    &__music {
      display: flex;
      margin-bottom: 2rem;
    }
    &__music-pink-square {
      width: 1rem;
      height: 1rem;
      background-color: #df2860;
      margin-right: 1rem;
    }
    &__song:hover {
      color: #df2860;
    }
    .photoContentWithoutPhoto {
      background-image: url('/img/zaslepa.jpg') !important;
    }
  }
</style>
